import { useI18n } from '../i18n'
import { mediaDuration, mediaTypeCounts, mediaTypeOf } from '../lib/mediaPresentation'
import '../styles/components/media-presentation.css'

export default function MediaTypeLabel({ item }) {
  const { t } = useI18n()
  const type = mediaTypeOf(item)
  const duration = mediaDuration(item)
  return (
    <span className={`media-kind-label media-kind-label--${type}`}>
      {t(`media.type.${type}`)}{duration ? ` · ${duration}` : ''}
    </span>
  )
}

export function MediaComposition({ items }) {
  const { t } = useI18n()
  const counts = mediaTypeCounts(items)
  if (!counts.length) return null
  return (
    <span className="media-composition" title={t('media.composition.hint')}>
      {counts.map(([type, count]) => t(`media.count.${type}`, { count })).join(' · ')}
    </span>
  )
}
